/**
 * Feature flags that control features exposed to the public faced app (e.g.
 * rooms view page)
 */
const publicFeatureFlags = `
  assetsAccess
  conversationAttachments
  disableRoomStickyColumns
  hidePoweredBy
  multipleSignables
  newPdfViewer
  richTextEditor
  richTextEditorMentions
  roomTextBox
  sectionHeaderIconColor
  showAllCollaborators
  smsNotifications
  pageLevelAnalytics
  downloadableOptionForAssetHubContents
  autoRoomCreation
`;

/**
 * Feature flags that control features with limited audience on the logged-in
 * (private) app (e.g. experimental features or not yet publicly available)
 */
const privateFeatureFlags = `
  ${publicFeatureFlags}
  addContentsToRoomFromTemplate
  callAiVideoFrameSelection
  allowSkipDeal
  bannerCrop
  crmFieldsWrites
  crmInfoSearch
  disableSort
  editCopy
  exportRoomVisits
  forceRoomsDealCreation
  fullTextSearch
  generalExportReport
  insightsOptimization
  insightsOptimizationV2
  roomsDealsExport
  inhouseConsent
  inhouseSigner
  insightsContentWonDeals
  internalRoomsV2
  openAi
  privacyPolicyConfig
  rolePermission
  roomBlacklistDomains
  slackIntegration
  vanityUrlFeature
  enforcedAllowedViewersOnly
  enforcedRequiredPin
  enforcedRequiredEmail
`;

export const getMeOrgFields = `
  ${privateFeatureFlags}
  id
  activeUsersCount
  address
  allowSupportLogin
  contentIndexingStatus
  convertApiEnabled
  createdAt
  crmIntegrationFeature
  callAiTranscriptEnabled
  discoveryReason
  email
  emailSenderConfigurable
  employeeRange
  gongStorageProvider
  languages
  logo
  mutualActionPlans
  name
  tenantType
  pdfViewerLicenseKey
  phone
  primaryUsage
  privacyPolicyLink
  privacyPolicyName
  referenceManagement
  ringCentral
  ringcentralStorageProvider
  sharedLinks
  signablesFeature
  signableTemplates
  status
  subscriptionStatus
  totalUsersCount
  vanityUrl
  vendorId
  vendorTenantId
  vendorTenantUrl
  website
  zoomStorageProvider
  orgSubscription {
    id
    createdAt
    frequency
    licenses
    licensesSelfServe
    manageUrl
    status
    trialEndDate
    usedLicensesCount
    plan {
      uuid
      name
    }
  }
  vendor {
    analyticsPrefix
    homeUrl
    name
    emailSenderName
    pdfViewerLicenseKey
    privacyPolicyLink
  }
`;

export const settingsOrgFields = `
  id
  actionPlanLabel
  bannerAssetId
  bannerUri
  colors
  disableRoomStickyColumns
  disableSort
  domainBlacklist
  domainWhitelist
  faviconUri
  fonts
  geoTargetConsent
  pageDescription
  pageTitle
  privacyPolicyLink
  privacyPolicyName
  scheduleCall
  website
`;

export const settingsUpdateOrgFields = `
  id
  actionPlanLabel
  bannerAssetId
  bannerUri
  colors
  consentContactEnrichmentEvents {
    id
    user {
      fullName
    }
    meta
    createdAt
  }
  dataEnrichment
  disableRoomStickyColumns
  disableSort
  domainWhitelist
  faviconUri
  fonts
  geoTargetConsent
  pageDescription
  pageTitle
  privacyPolicyLink
  privacyPolicyName
  scheduleCall
  website
`;

export const updateOrgFields = `
  consentContactEnrichmentEvents {
    id
    user {
      fullName
    }
    meta
    createdAt
  }
`;

export const integrationOrgFields = `
  id
  crmIntegration {
    id
    configuration
    createdAt
    providerName
    updatedAt
    version
    logs(limit: 5) {
      createdAt
      results
      source
      status
      transactionId
    }
  }
`;

export const crmIntegrationProviderName = `
  id
  crmIntegration {
    id
    providerName
  }
`;

export const roomOrgFields = `
  ${publicFeatureFlags}
  id
  actionPlanLabel
  colors
  convertApiEnabled
  fonts
  isCurrentUserMember
  logo
  name
  tenantType
  pageTitle
  pdfViewerLicenseKey
  privacyPolicyLink
  privacyPolicyName
  inhouseConsent
  scheduleCall
  vanityUrl
  vendorTenantId
  vendorTenantUrl
  website
  vendor {
    homeUrl
    name
    pdfViewerLicenseKey
    privacyPolicyLink
  }
`;

export const roomSettingsOrgFields = `
  ${settingsOrgFields}
  ${integrationOrgFields}
`;

export const libraryFilters = `
  libraryFilters
  fullTextSearch
`;

export const integrationBasicFields = `
  crmIntegration {
    id
  }
`;

export const domainBlacklistFields = `
  domainBlacklist
`;

export const integrationOrgConfigFields = `
  id
  crmIntegration {
    id
    configuration
    providerName
    notificationUser {
      id
      fullName
    }
  }
`;

export const integrationOrgConfigDealFields = `
  id
  crmIntegration {
    id
    configuration
    providerName
  }
`;
